import React from "react";
import { EyeOutlined } from '@ant-design/icons';
import DepartmentHeadRecommendationViewController from "../View/DepartmentHeadRecommendationView.controller";
import ViewAction from "../../../../../../components/Actions/ViewAction";

export const DepartmentHeadRecommendationAction = {
    COMMON_ACTION: {
        VIEW: {
            type: 'item',
            title: 'View Department Head Recommendation',
            action: 'view',
            link: { to: '' },
            permission: '',
            component: DepartmentHeadRecommendationViewController,
            className: 'grid-view-action',
            icon: '',
        },
    },
    LIST_ITEM_ACTION: [
        {
            type: 'item',
            title: 'View',
            action: 'active',
            link: { to: '' },
            permission: '',
            component: ViewAction,
            className: 'grid-view-action',
            icon: '',
        }
    ],
    BULK_ACTION: {
        permission: 'grant:departmentHeadRecommendation:multiSelect',
        action_list: [
            {
                type: 'item',
                title: 'Mark as Active',
                action: 'active',
                link: { to: '' },
                component: '',
                className: 'grid-view-action',
                icon: <EyeOutlined />,
            },
            {
                type: 'item',
                title: 'Mark as Inactive',
                action: 'inactive',
                link: { to: '' },
                component: '',
                className: 'grid-view-action',
                icon: <EyeOutlined />,
            }
        ],
    },
}


